import Groups from "./Groups"

export default  Groups;



// WEBPACK FOOTER //
// ./src/components/App/SubscriptionManagerDashboard/SubscriptionsWithGroups/Groups/index.js